// src/components/home/Footer.jsx
import React, { useState, useEffect } from "react";
import SocialIcon from "./SocialIcon";
import facebookIcon from "../../assets/images/socialMediaIcon/facebook.svg";
import instagramIcon from "../../assets/images/socialMediaIcon/instagram.svg";
import xIcon from "../../assets/images/socialMediaIcon/x.svg";
import youtubeIcon from "../../assets/images/socialMediaIcon/youtube.svg";
import xiaohongshuIcon from "../../assets/images/socialMediaIcon/xiaohongshu.svg";
import logoImage from "../../assets/images/logo/LIA_logo.png";
import { db } from "../../firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default function Footer() {
  const [scale, setScale] = useState(1);
  const [links, setLinks] = useState({});

  // 响应式调整
  useEffect(() => {
    const updateScale = () => {
      const containerWidth = window.innerWidth;

      // 基础总宽度：5个图标 × 184px + 4个间隙 × 60px = 1080px
      const baseWidth = 1080;

      // 如果容器宽度小于基础宽度，计算缩放比例
      if (containerWidth < baseWidth) {
        // 使用90%的容器宽度作为目标宽度，确保有足够边距
        const targetWidth = containerWidth * 0.9;
        const newScale = Math.max(0.5, targetWidth / baseWidth); // 最小缩放到0.5
        setScale(newScale);
      } else {
        setScale(1);
      }
    };

    // 初始调用
    updateScale();

    // 监听窗口大小变化
    window.addEventListener('resize', updateScale);

    // 清理监听器
    return () => window.removeEventListener('resize', updateScale);
  }, []);

  // 订阅社交链接
  useEffect(() => {
    const ref = doc(db, "meta", "socialLinks");
    const unsub = onSnapshot(ref, (snap) => {
      setLinks(snap.exists() ? snap.data() : {});
    });
    return () => unsub();
  }, []);

  return (
    <footer
      style={{
        backgroundColor: "rgb(0, 48, 113)",
        color: "white",
        paddingTop: "30px",
        paddingBottom: "10px",
      }}
    >
      <div className="container">
        <div className="row align-items-start">
          {/* 左侧：联系信息 */}
          <div className="col-md-4 col-12 mb-3" style={{ marginTop: "30px" }}>
            <h5 style={{ fontWeight: "bold", marginBottom: "0.4rem" }}>
              LIA LEARNING
            </h5>
            <div style={{ display: "flex", flexDirection: "column", gap: "0px", marginTop: "-1.2rem" }}>
              <p style={{ color: "#ccc", margin: 0 }}>
                <a
                  href="https://maps.app.goo.gl/qKWDmbQRu1Kkr7mE9"
                  className="hover-underline-slide"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  6900 JERICHO TPKE, SUITE LL100,<br />
                  Syosset, NY 11791
                </a>
              </p>
              <p style={{ color: "#ccc", marginTop: "-2.5rem" }}>
                <strong style={{ color: "white" }}>Office</strong>{" "}
                <a
                  href="tel:+15167168888"
                  className="hover-underline-slide"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  (516)716-8888
                </a>{" "}
                <strong style={{ color: "white" }}>Text</strong>{" "}
                <a
                  href="tel:+15166906900"
                  className="hover-underline-slide"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  (516)690-6900
                </a>
                <br />
                <strong style={{ color: "white" }}>Email</strong>{" "}
                <a
                  href="mailto:info@lialearning.com"
                  className="hover-underline-slide"
                  style={{ color: "#ccc", textDecoration: "none", textTransform: "uppercase" }}
                >
                  INFO@LIALEARNING.COM
                </a>
              </p>
            </div>
          </div>

          {/* 右侧：品牌标识 + 社交图标 */}
          <div className="col-md-8 col-12 d-flex flex-column align-items-center text-center">
            {/* 品牌 logo + 标题 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <img
                src={logoImage}
                alt="LIA Logo"
                style={{
                  height: "60px",
                  marginBottom: "0px",
                }}
              />

              <h2
                style={{
                  fontWeight: "bold",
                  marginTop: "-0.5rem",
                  fontSize: "3rem",
                  marginBottom: "0",
                }}
              >
                Long Island Academy
              </h2>
            </div>

            <p
              style={{
                fontSize: "1rem",
                color: "white",
                fontWeight: "normal",
                textTransform: "none",
                marginTop: "-1.2rem",
              }}
            >
              Syosset | Since 1990
            </p>

            {/* 社交图标区域 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "60px",
                marginTop: "-10px",
                flexWrap: "wrap",
                justifyContent: "center",
                transform: `scale(${scale})`,
                transformOrigin: "center center",
                width: scale < 1 ? `${100 / scale}%` : "auto",
                maxWidth: "100%",
              }}
            >
              <SocialIcon
                src={facebookIcon}
                alt="Facebook"
                link={links.facebook}
              />
              <SocialIcon
                src={instagramIcon}
                alt="Instagram"
                link={links.instagram}
              />
              <SocialIcon
                src={xIcon}
                alt="X"
                link={links.x}
              />
              <SocialIcon
                src={youtubeIcon}
                alt="YouTube"
                link={links.youtube}
              />
              <SocialIcon
                src={xiaohongshuIcon}
                alt="Xiaohongshu"
                link={links.xiaohongshu}
              />
            </div>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="row mt-4">
          <div className="col-md-12 text-center">
            <p style={{ fontSize: "0.6rem", marginTop: "-70px", color: "#ccc" }}>
              &copy; 2025 Long Island Academy. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
